import { Directive, Input, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[tooltip]'
})
export class TooltipDirective {
    @Input('tooltip') tooltipTitle: string;
    @Input() placement: string;
    @Input() placementModal: any = 0;
    @Input() delay: string;
    @Input() videoLink: string;
    @Input() videoTitle: string;
    @Input() customClass?: string;
    tooltip: HTMLElement;
    offset = 10;
    toggle = false;



    constructor(
        private el: ElementRef,
        private renderer: Renderer2) {
            this.placement = 'top';
        }

    @HostListener('mouseenter') onMouseEnter() {
        if (!this.placement) {
            this.placement = 'top';
        }
        if (!this.tooltip) { this.show(); }
    }
    @HostListener('mouseleave') onMouseLeave() {
        if (this.tooltip) { this.hide(); }
    }
    @HostListener('click') onClick() {
        if (!this.toggle) {
            if (!this.placement) {
                this.placement = 'top';
            }
            if (!this.tooltip) { this.show(); }
            this.toggle = true;
        } else {
            this.hide();
            this.toggle = false;
        }
    }

    show() {
        this.create();
        this.setPosition();
        this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
    }

    hide() {
        if (this.renderer && this.tooltip && this.tooltip.classList) {
            this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
        }
        window.setTimeout(() => {
            if (this.tooltip) {
                this.renderer.removeChild(this.el.nativeElement, this.tooltip);
            }
            this.tooltip = null;
        }, Number(this.delay));

    }

    create() {
        let placement = this.placement;
        const hostPos = this.el.nativeElement.getBoundingClientRect();
        this.tooltip = this.renderer.createElement('span');
        console.log(this.customClass);
        this.renderer.appendChild(
            this.tooltip,
            this.renderer.createText(this.tooltipTitle) // textNode
        );
        // tslint:disable-next-line:triple-equals
        if (this.placementModal == '1') {
            this.renderer.appendChild(document.body, this.tooltip);
        } else {
            this.renderer.appendChild(this.el.nativeElement, this.tooltip);
        }
        this.renderer.addClass(this.tooltip, 'ng-tooltip');
        // tslint:disable-next-line:triple-equals
        if (this.placement == 'right') {
            if (hostPos.right > (window.innerWidth - 150)) {
                placement = 'bottom';
            } else {
                const width = ((window.innerWidth - 20) - hostPos.right);
                this.renderer.setStyle(this.tooltip, 'max-width', `${width > 250 ? 250 : width}px`);
            }
        }
        this.renderer.addClass(this.tooltip, `ng-tooltip-${placement}`);
        if (this.customClass) {
            this.renderer.addClass(this.tooltip, `${this.customClass}`);
        } else {
            this.renderer.addClass(this.tooltip, `dark-theme`);
        }


        this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, 'transition', `opacity ${this.delay}ms`);
    }

    setPosition() {
        this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
        this.renderer.setStyle(this.tooltip, 'position', 'fixed');
        const hostPos = this.el.nativeElement.getBoundingClientRect();
        const tooltipPos = this.tooltip.getBoundingClientRect();
        let top, left;
        if (this.placement === 'top') {
            top = hostPos.top - tooltipPos.height - this.offset;
            left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
        }
        if (this.placement === 'bottom') {
            const left_pos = ((hostPos.right - (hostPos.width / 2)) + tooltipPos.width / 2);
            top = hostPos.bottom + this.offset;
            if (left_pos > window.innerWidth) {
                left = (hostPos.left + (hostPos.width - tooltipPos.width) / 2) - (left_pos - window.innerWidth);
            } else {
                left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
            }
            this.renderer.setAttribute(this.tooltip, `data-left-post`, left + 'px');
        }
        if (this.placement === 'left') {
            top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
            left = hostPos.left - tooltipPos.width - this.offset;
        }
        if (this.placement === 'right') {
            if (hostPos.right > (window.innerWidth - 150)) {
                const left_pos = ((hostPos.right - (hostPos.width / 2)) + tooltipPos.width / 2);
                top = hostPos.bottom + this.offset;
                if (left_pos > window.innerWidth) {
                    left = (hostPos.left + (hostPos.width - tooltipPos.width) / 2) - (left_pos - window.innerWidth);
                } else {
                    left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
                }
            } else {
                top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
                left = hostPos.right + this.offset;
            }
        }
        this.renderer.setStyle(this.tooltip, 'top', `${top}px`);
        this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
    }
}
